import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import ListTitle from '../../../../components/listTitle';
import AutoArea from './autoArea';
import { getAutoAreaData } from '../../../../../utils/autoArea';

class AutoBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        autoAreaData: '',
    };

    async componentDidMount() {
        const autoAreaData = await getAutoAreaData();

        this.setState({
            autoAreaData,
        });
    }

    render() {
        const { autoAreaData } = this.state;
        const {
            content: { autoTopic, autoTitle0, autoTitle1, autoList0, autoList1, autoList2, autoListAd },
        } = this.props;

        return (
            <div id="autoNewsList" className={styles.auto_box}>
                <Chip id="50066" type="struct" title="汽车栏标题" groupName="汽车栏" content={autoTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75053"
                    type="recommend"
                    title="汽车栏头条1"
                    groupName="汽车栏"
                    content={autoTitle0}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75054"
                    type="recommend"
                    title="汽车栏新闻列表1"
                    groupName="汽车栏"
                    content={autoList0}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75055"
                    type="recommend"
                    title="汽车栏头条2"
                    groupName="汽车栏"
                    content={autoTitle1}
                    translate="handleNewsContentData">
                    <ListTitle />
                </Chip>
                {autoAreaData && autoAreaData !== '' ? (
                    <AutoArea content={autoAreaData} />
                ) : (
                    <Chip
                        id="75056"
                        type="recommend"
                        title="汽车栏新闻列表2"
                        groupName="汽车栏"
                        content={autoList1}
                        translate="handleNewsContentData">
                        <NewsList isList />
                    </Chip>
                )}
                <Chip
                    id="75057"
                    type="recommend"
                    title="汽车栏新闻列表3"
                    groupName="汽车栏"
                    content={autoList2}
                    translate="handleNewsContentData">
                    <NewsList isList ad={autoListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(AutoBox);
